module.exports = __webpack_public_path__ + "img/todo-list.4b5ccffa.png";